import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {Object} UpdateTeacherStudentsPayload
 * @property {"assign" | "unassign"} action - The action to perform
 * @property {number} teacher_id - The ID of the teacher
 * @property {number[]} student_ids - Array of student IDs to assign/unassign
 */

/**
 * Hook to assign or unassign students from a teacher
 */
export const useUpdateTeacherStudents = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * Update students for a teacher (assign/unassign)
   * @param {UpdateTeacherStudentsPayload} payload - The payload for the request
   * @param {() => void} [onSuccess] - Callback function to be called on success
   */
  const updateTeacherStudents = async (payload, onSuccess) => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/school/admin/teacher/update-students`,
        payload,
      );

      if (onSuccess) {
        onSuccess(response.data);
      }
      return response.data;
    } catch (err) {
      if (err?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        const apiErrors = err?.response?.data?.errors;
        const firstError = apiErrors && Object.values(apiErrors)?.[0]?.[0];

        setError(
          firstError || err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN,
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return { updateTeacherStudents, loading, error };
};
